var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { SearchOrder } from "./SearchOrder";
export class SearchResponse {
  constructor(_data) {
    /**
     */
    __publicField(this, "Count");
    /**
     */
    __publicField(this, "Orders");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SearchResponse
     */
    __publicField(this, "$type", "V1.Orders.Search.SearchResponse");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Count = _data["Count"];
      if (_data["Orders"] && _data["Orders"].constructor === Array) {
        this.Orders = [];
        for (let item of _data["Orders"]) {
          const orders_ = new SearchOrder();
          this.Orders.push(orders_.init(item));
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Count"] = this.Count;
    if (this.Orders && this.Orders.constructor === Array) {
      _data["Orders"] = [];
      for (let item of this.Orders) {
        _data["Orders"].push(item.toJSON());
      }
    }
    return _data;
  }
}
